<template>
  <div class="vertical-centering spacex-4 pointer mr-11">
    <InfoIcon class="icon-d-600 icon-16px" />
    <span class="danger-600 text-sm">{{ $t('An unknown error occured, please try again') }}</span>
  </div>
</template>

<script>
  import InfoIcon from '@/assets/icons/info-filled.svg';

  export default {
    name: 'DefaultErrorText',
    components: {
      InfoIcon,
    },
  };
</script>

<style scoped></style>
